module.exports = __webpack_public_path__ + "static/img/rz(5).216bc160.jpg";